<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <v-row v-for="(item, index) in contentTypes" :key="index">
      <v-col cols="12" md="1">
        <v-btn large @click="remove(index)" icon color="red darken-4">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="item.contentType.name"
          v-bind:label="$t('Name')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-switch
          color="primary"
          v-model="item.contentType.encryptDocuments"
          v-bind:label="$t('Encrypted')"
        ></v-switch>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          multiple
          v-bind:label="$t('Roles')"
          item-text="text"
          item-value="text"
          v-model="item.roles"
          :items="roles"
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <div style="position: absolute; bottom: 0px; left: 25px">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-file-input
                v-on="on"
                @change="onImport"
                accept=".json"
                prepend-icon="mdi-file-import-outline"
              ></v-file-input>
            </div>
          </template>
          <span>{{ $t("ImportFromFile") + " (JSON)" }}</span>
        </v-tooltip>
      </div>
    </template>
  </base-modal>
</template>
<script>
import ContentTypeService from "@/services/ContentTypeService";
import RoleService from "@/services/RoleService";
import ContentType from "@/ecm/models/ContentTypeImport";
import Utils from "@/ecm/common/Utils";
export default {
  name: "ContentTypeImportModal",
  created() {
    RoleService.getList().then(data => {
      this.roles = data;
    });
  },
  data() {
    return {
      roles: [],
      contentTypes: [],
      modal: {
        title: `${this.$t("ContentTypes")} - ${this.$t("Import")}`,
        key: "contentTypeImportModal"
      },
      open: false
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    }
  },
  methods: {
    save() {
      this.modalInstance.progress(true);
      var ctImport = this.contentTypes.map(function(obj) {
        return obj.toDto();
      });
      ContentTypeService.import(ctImport)
        .then(result => {
          Utils.toast.success(this.$t("ContentType") + " " + this.$t("ImportedSuccessfully"));
          this.$emit("on-imported");
          this.hide();
        })
        .catch(error => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    remove(index) {
      this.contentTypes.splice(index, 1);
    },
    onImport(file) {
      if (file) {
        const reader = new FileReader();
        var self = this;
        reader.onload = function() {
          if (reader.result) {
            try {
              var importData = JSON.parse(reader.result);
              self.contentTypes = importData.map(function(dto) {
                return new ContentType(dto);
              });
            } catch (error) {
              Utils.toast.error(self.$t("UnsupportedFileFormatException"));
            }
          }
        };
        reader.readAsText(file);
      } else {
        this.contentTypes = [];
      }
    },
    new() {
      this.contentTypes = [];
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    }
  }
};
</script>
